import React, { Fragment, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import axios from "axios";
import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Pagination,
  PaginationItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import _ from "lodash";
import { useStyle } from "../style";
import { Helmet } from "react-helmet-async";
import { Delete, ExitToApp, Save } from "@mui/icons-material";
import moment from "moment";
import TempData from "./tempData";
import CloseIcon from "@mui/icons-material/Close";
import { debounce } from 'lodash';
import { makeStyles } from '@mui/styles';
import ReactMemo from 'react';
import { ArrowLeftIcon, ArrowRightIcon } from "@mui/x-date-pickers";
import DialogCancel from "../../../../../components/utils/dialogCancel/dialogCancel";
import { useNavigate } from "react-router-dom";

const ClosingStockExpense = () => {
  const classes = useStyle();
  const dispatch = useDispatch();
  const [catData, setCatData] = useState([]);
  const [allSubData, setAllSubData] = useState([]);
  const [subData, setSubData] = useState([]);
  const [itemData, setItemData] = useState(null);
  const [qty, setQty] = useState("");
  const [salesMan, setSalesMan] = useState([]);
  const [tempData, setTempData] = useState([]);
  const [pendingData, setPendingData] = useState([]);
  const [barcode, setBarcode] = useState(''); // State to store the barcode value
  const [options, setOptions] = useState({
    category: null,
    subCategory: null,
    salesManId: null,
  });
  const [postData, setPostData] = useState({
    // closing_data_outlet: [],
  });
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isDialogOpenCancel, setIsDialogOpenCancel] = useState(false);

  const roleId = localStorage.getItem("role_id")
  const [data, setData] = useState([]);
  const [code, setCode] = useState("");
  const [editingIndex, setEditingIndex] = useState(null);
  const codeRef = useRef(null);
  const [count, setCount] = useState(0);
  const outletId = localStorage.getItem("outlet_id");
  const [isPendingDisabled, setIsPendingDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(100); // Set the rows per page
  const [rateData, setRateData] = useState({
    mrp: "",
    disc: "",
    rate: "",
    gst: "",
    qty: "",
  });
    const [dialogClose, setDialogClose] = useState(false);
    const [dialogClose1, setDialogClose1] = useState(false);
  
  const [open, setOpen] = useState(false)
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [page, setPage] = useState(0);
  const pageCount = Math.ceil(tempData.length / rowsPerPage);
  const qtyRef = useRef(null);
  const tableRef = useRef(null);
  // function handleChangeValue(value, name) {
  //   codeRef.current.focus()
  //   setOptions((prev) => ({ ...prev, [name]: value }));
  //   setCount(0);
  //   if (name === "category") {
  //     setOptions((prev) => ({ ...prev, subCategory: null }));
  //     filterSubCategories(value ? value.id : null);
  //   }
  // }
    const navigate = useNavigate();
  const openDialog = () => {
    setIsDialogOpen(true);
};

const closeDialog = () => {
    setIsDialogOpen(false);
};
const closeDeleteDialog = () => {
    setIsDialogOpenCancel(false);
};
const onClickCancel = () => {
  setDialogClose(false);
};
const onClickCancelDelete = () => {
  setDialogClose1(false);
};
const onClickExit = () => {
  navigate("/");
};
// console.log(paymentDetails)
const handleExit = () => {
  setDialogClose(true);
};
const handleCancelButton = () => {
  setIsDialogOpenCancel(true);
};
  function handleChangeValue(value, name) {
    if (codeRef.current) {
      codeRef.current.focus();
    }
    setOptions((prev) => ({ ...prev, [name]: value }));
    setCount(0);
  
    if (name === "category") {
      setOptions((prev) => ({ ...prev, subCategory: null }));
      filterSubCategories(value ? value.id : null);
    }
  }
  
  function getCategory() {
    axios
      .get("/v1/categories")
      .then((res) => {
        const activeCategories = _.filter(res.data, (val) => val.is_active);
        setCatData(activeCategories);
      })
      .catch((err) => {
        // console.log(err);
        dispatch(setSnackbar(true, "error", err.response.data.error));
      });
  }

  function getSubCategory() {
    axios
      .get("/v1/subcategories")
      .then((res) => {
        setAllSubData(res.data);
      })
      .catch((err) => {
        // console.log(err);
        dispatch(setSnackbar(true, "error", err.response.data.error));
      });
  }
  function getSalesMan() {
    const outletId = options?.outletId || localStorage.getItem("outlet_id"); // Retrieve outlet ID from options or localStorage

    axios
      .get(`/v1/SalesMan/outlets/${outletId}`)
      .then((res) => setSalesMan(res.data))
      .catch((err) => {
        // console.log(err);
        dispatch(setSnackbar(true, "error", err.response.data.error));
      });
  }
  function getTempDetails() {
    setLoading(true);

    const tData = {
      cat_id: options.category != null ? options.category.id : 0,
      sub_cat_id: options.subCategory != null ? options.subCategory.id : 0,
      outlet_id : outletId
    };
    axios
      .post(`/v1/outlet/closing_stock_temp_details`, tData)
      .then((res) => {
        setTempData(res.data);
      })
      .catch((err) => {
        
      })
      .finally(()=>{
        setLoading(false);

      });
  }
  // function getPendingDetails() {
  //   const tData = {
  //     cat_id: options.category != null ? options.category.id : 0,
  //     // sub_cat_id: options.subCategory != null ? options.subCategory.id : 0,
  //     outlet_id : outletId
  //   };
  //   axios
  //     .post(`/v1/closing_stock_outlet/pending/stocks`, tData)
  //     .then((res) => {
  //       console.log(res);
  //       setPendingData(res.data);
  //       setIsPendingDisabled(!res.data || res.data.length === 0); // Disable button if response is empty

  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       setIsPendingDisabled(true); // Disable button on error

  //     });
  // }
  function getPendingDetails() {
    const outletId = options?.outletId || localStorage.getItem("outlet_id"); // Retrieve outlet ID from options or localStorage
    const categoryId = options?.category?.id || 0; // Get category ID, default to 0
    const subCategoryId = options?.subCategory?.id || 0; // Get sub-category ID, default to 0
  
    const url = `/v1/closing_stock_outlet/pending/stocks/${outletId}/${categoryId}/${subCategoryId}`;
  
    axios
      .get(url, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((res) => {
        // console.log(res);
        setPendingData(res.data); // Set pending data
        setIsPendingDisabled(!res.data || res.data.length === 0); // Disable button if response is empty
      })
      .catch((err) => {
        console.error("Error:", err);
        setIsPendingDisabled(true); // Disable button on error
        dispatch(setSnackbar(true, "error", err.response?.data?.error || "Failed to fetch pending details"));
      });
  }

  
  const handleAddRow = (e) => {
    if (e.key === "Enter" && qty !== "") {
      if (qtyRef.current) {
        qtyRef.current.focus();
      }
      const objData = {
        code: code,
        qty: qty,
        ...itemData,
      };
      const existingItemIndex = data.findIndex(
        (item) =>
          item.code === objData.code &&
          (item.mrp1 === objData.mrp || item.mrp1 === objData.mrp1)
      );
      const arr = [...data];
      setData([]);
      if (existingItemIndex !== -1) {
        // If the item exists, update its quantity, gst, cess, total
        arr[existingItemIndex].qty =
          parseFloat(arr[existingItemIndex].qty) + parseFloat(objData.qty);
        arr[existingItemIndex].gstAmt =
          (parseFloat(arr[existingItemIndex].rate1) -
            parseFloat(arr[existingItemIndex].rate1) *
              parseFloat(arr[existingItemIndex].disc1 / 100)) *
          parseFloat(arr[existingItemIndex].gst1 / 100) *
          parseFloat(arr[existingItemIndex].qty);
        arr[existingItemIndex].cessAmt =
          (parseFloat(arr[existingItemIndex].rate1) -
            parseFloat(arr[existingItemIndex].rate1) *
              parseFloat(arr[existingItemIndex].disc1 / 100)) *
          parseFloat(arr[existingItemIndex].cess / 100) *
          parseFloat(arr[existingItemIndex].qty);
        arr[existingItemIndex].totalAmt =
          (parseFloat(arr[existingItemIndex].rate1) -
            parseFloat(arr[existingItemIndex].rate1) *
              parseFloat(arr[existingItemIndex].disc1 / 100)) *
          parseFloat(arr[existingItemIndex].qty);
        setData(arr);
      } else {
        // If the item doesn't exist, add it to the 'data' array
        arr.push(objData);
        setData(arr);
      }
      setCode("");
      setQty("");
      setItemData(null);
      setRateData((prevData) => ({
        ...prevData,
        mrp: "",
        rate: "",
        gst: "",
        disc: "",
      }));
      codeRef.current.focus();
    }
  };
  const handleQtyChange = (e) => {
    setQty(e.target.value);
  };
  function filterSubCategories(categoryId) {
    if (categoryId) {
      const filteredSubData = allSubData.filter(
        (sub) => sub.category_id === categoryId
      );
      setSubData(filteredSubData);
    } else {
      setSubData([]);
    }
  }
  const handleCodeKeyPress = (e) => {
    // console.log(e);
    // console.log(code);
    if (e.key === "Enter" && code !== "") {
      e.preventDefault(); // Prevent default behavior for the Enter key.
      getItemCode(code)
    }
  };
  const handleCodeChange = useCallback((e) => {
    // setCode(e.target.value);
    setCode(e.target.value.toUpperCase());

  }, []); // The function is memoized and will not be re-created on each render


  // const handleCodeChange = (e) => {
  //   setCode(e.target.value);
  //   // .replace(/\D/g, "")
  // };
  const getItemCode = (id) => {
 
    if (options.salesManId != null) {
      axios
        .get(
          `/v1/itemdetails/closingStock/barcode/${id}/${outletId}/${
            options.category != null ? options.category.id : 0
          }/${options.subCategory != null ? options.subCategory.id : 0}`
        )
        .then((res) => {
          setItemData(res.data);
          // console.log(itemData);
          setQty("1");

          // console.log(res.data);
          tempPostData(res.data);
          const objData = {
            code: id,
            qty: "1",
            ...res.data,
          };
          // console.log(data);
          if (data.length > 0) {
            const existingItemIndex = data.findIndex(
              (item) =>
                item.code === objData.code &&
                (item.mrp1 === objData.mrp || item.mrp1 === objData.mrp1)
            );
            const arr = [...data];
            const existingTempData = tempData.find((item) => item.barcode === code);
            // console.log(existingTempData,tempData,"Enna ithu")
            if (existingTempData ) {
              dispatch(setSnackbar(true, "success", "Barcode already exists!"));
              setCode("");
            } else {
              arr.push(objData);
              setData(arr);
              // console.log(data);
            }
            setData((prevData) => {
              // If item is not already in the list, add it at the beginning
              return [objData, ...prevData]; // Prepending to the start
            });
            setCode("");
            setQty("");
            setItemData(null);
            // codeRef.current.focus();
          } else {
            const arr = [...data];
            arr.push(objData);

            setData(arr);
            setCode("");
            setQty("");
            setItemData(null);
            // codeRef.current.focus();
          }
        })
        .catch((err) => {
          // console.log(err,"errorcheck");
          // console.log(err.response.data.errors[0].message)
        
          
          dispatch(
            setSnackbar( 
              true,
              "error",
              `${err.response?.data.errors[0].message}`
            )
          );
        
          setCode("");
        // Clear the code field
       
        });
    } else {
      dispatch(setSnackbar(true, "error", "Please select salesman"));
      setCode("");
    }
  };

  const handleTempSaveResponse = (response) => {
    if (response.success) {
      const newTempData = [...tempData, response.data];
      const sortedData = newTempData.sort((a, b) => b.barcode.localeCompare(a.barcode)); // Sort in descending order

      setTempData(sortedData);
      // setTempData(newTempData);
      // Assuming response.data contains prod_id

    }
  };
  
  const tempPostData = (dataItem) => {
    setLoading(true);
  
    const tempDetails = {
      prod_id: dataItem.prod_id,
      cat_id: dataItem.cat_id,
      sub_cat_id: dataItem.sub_cat,
      barcode: dataItem.barcode,
      outlet_id: outletId,
      sales_man_id: options.salesManId != null ? options.salesManId.id : 0,
    };
  
    axios
      .post(`/v1/outlet/closing_stock_temp`, tempDetails)
      .then((res) => {
        handleTempSaveResponse(res.data); // Update tempData with API response
        dispatch(setSnackbar(true, "success", "Barcode Saved Successfully!"));
        
      })
      .catch((err) => {
        setCode([]);
        dispatch(setSnackbar(true, "error", "Barcode already processed"));
      })
      .finally(() => {
        setLoading(false);
      });
  };
  
  
  const clearNew = () => {
    setCode("");
    setQty("");
    setItemData(null);
    setRateData((prevData) => ({
      ...prevData,
      mrp: "",
      rate: "",
      gst: "",
      disc: "",
    }));
    codeRef.current.focus();
  };
  function getSelectedRow(e) {
    setEditingIndex(e);
  }

  const getCount = () => {
    const catSubData = {
      cat_id: options.category != null ? options.category.id : 0,
      sub_cat_id: options.subCategory != null ? options.subCategory.id : 0,
      outlet_id : outletId
    };
    axios
      .post(`/v1/outlet/closing_stock_count`, catSubData)
      .then((res) => {
        if(res.data!==""){
          setCount(res.data.total);
        }
      })
      .catch((err) => {
        // console.log(err);
      });
  };
  const handleSaveClick = () => {
    // if (data.length === 0) {
    //     dispatch(setSnackbar(true, 'error', 'No Data Found'));
    // } else {
    //     openDialog();
    // }
    openDialog();
};

  const handleSubmit = () => {
    if (tempData.length === 0) {
      dispatch(setSnackbar(true, "error", "No Data Found"));
    } else {
      const postData = {
        cat_id: options.category != null ? options.category.id : 0,
        sub_cat_id: options.subCategory != null ? options.subCategory.id : 0,
        // outlet_id : outletId
        outlet_id: Number(outletId),
      };
      axios.post(`/v1/closing_stock_outlet`, postData)
        .then((res) => {
          dispatch(setSnackbar(true, "success", "Bill Saved Successfully"));
          // setTimeout(() => {
          //   window.location.reload();
          // }, 1000);
          getTempDetails();
          getCount();
          setData([]);
          getPendingDetails()

        })
        .catch((err) => {
          dispatch(
            setSnackbar(true, "error", err.response.data.errors[0].message)
          );
        });
    }
    closeDialog();
  };
  const handleCancel = () => {
   const cancelData = {
      cat_id: options.category != null ? options.category.id : 0,
      sub_cat_id: options.subCategory != null ? options.subCategory.id : 0,
      outlet_id : outletId
   }
    axios.post(`/v1/outlet/closing_stock_temp/cancel` , cancelData)
    .then((res) => {
      getTempDetails();
      getCount();
      setTimeout(() => {
        window.location.reload();
      }, 1000);
     setData([])
    })
    .catch((err) => {
      // console.log(err)
    })
  }
  const handleDeleteRow = (e) => {
    const deleteRow = {
      prod_id : e.prod_id ,
      barcode : e.barcode
    }
    console.log(deleteRow)
    axios.post(`/v1/outlet/closing_stock_temp/delete` , deleteRow)
    .then((res) => {
      // console.log(res)
      dispatch(setSnackbar(true , 'success' , 'Deleted successfully'))
      getTempDetails()
    })
    .catch((err) => {
      // console.log(err)
    })
  }


  
  useEffect(() => {
    getCategory();
    getSubCategory();
    getSalesMan();
  }, []);
  useEffect(() => {
    if (options.category) {
      filterSubCategories(options.category.id);
      getCount();
      getTempDetails();
    }
  }, [options.category]);
  useEffect(() => {
    if (options.category !== null && outletId) {
      getCount();
      getTempDetails();
       getPendingDetails()
    }
  }, [options]);
  useEffect(()=>{
    getPendingDetails()

  },[])

  useEffect(() => {
    if (tempData.length > 0) {
      let arr = [];
      tempData.forEach((val) => {
        const obj = {
          docdate: moment().format("YYYY-MM-DD"),
          physical_qty: 1,
          prodid: val.prod_id,
          company_id: 1,
          uid:  options.salesManId != null ? options.salesManId.id : 0,
          barcode: val.barcode,
          outlet_id: outletId,
          cat_id: options.category != null ? options.category.id : 0,
          sub_cat_id: options.subCategory != null ? options.subCategory.id : 0,
        };
        arr.push(obj);
      });
  
      // Set the combined data to closing_data_outlet
      setPostData((prevState) => ({
        ...prevState,
        closing_data_outlet: arr,
      }));
    }
  }, [data, tempData, outletId]);
   // Handle page change for pagination
   const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Handle rows per page change for pagination
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0); // Reset to page 0 on rows per page change
  };

  // Memoize the rows for performance optimization
  const rows = useMemo(() => {
    return tempData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  }, [tempData, page, rowsPerPage]);

console.log("Rows Length:", rows.length);


// console.log(tempData,"What is this")
  // console.log(options)
  // console.log(options.subCategory != null && options.subCategory.id)
// TableRow component memoized to prevent unnecessary re-renders
const MemoizedTableRow = React.memo(({ value, idx, handleDeleteRow }) => {
  return (
    <TableRow className={classes.tablrow} key={idx}>
      <TableCell padding="checkbox" className={classes.tblContentCell} sx={{ borderLeft: "0.5px solid  #ccc" }}>
        {idx + 1}
      </TableCell>
      <TableCell>{value.barcode}</TableCell>
      <TableCell variant="body" cclassName={classes.tblContentCell}>
        {value.pro_name}
      </TableCell>
      <TableCell className={classes.tblContentCell} sx={{ width: 100 }}>
        {/* <IconButton onClick={() => handleDeleteRow(value)}> */}
          <Delete sx={{ color: 'red', fontSize: 18 }} 
          onClick={() => handleDeleteRow(value)}
          />
        {/* </IconButton> */}
      </TableCell>
    </TableRow>
  );
});

  return (
    <Fragment>
      <Grid className={classes.root}>
        <Helmet><title>Outlet Closing Stock</title></Helmet>
        <Grid className={classes.titleInfo}>
          <Typography variant="h5" fontWeight={600}>Closing Stock</Typography>
        </Grid>
        <Grid container spacing={2} className="p-3">
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Autocomplete
              size="small"
              value={options.category}
              options={catData}
              getOptionLabel={(option) => option.category_name}
              onChange={(e, value) => handleChangeValue(value, "category")}
              renderInput={(params) => (
                <TextField {...params} label="Category" />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Autocomplete
              size="small"
              // options={[{id:0,subcategory_name:"All"}, ...subData]}
              options={subData}
              value={options.subCategory}
              getOptionLabel={(option) => option.subcategory_name}
              onChange={(e, value) => handleChangeValue(value, "subCategory")}
              disabled={options.category == null}
              renderInput={(params) => (
                <TextField {...params} label="Sub Category" />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Autocomplete
              id="salesman"
              name="salesman"
              size="small"
              options={salesMan}
              getOptionLabel={(option) =>
                `${option.sales_man_name} - ${option.sales_man_code}`
              }
              value={options.salesManId}
              onChange={(e, value) => handleChangeValue(value, "salesManId")}
              disableClearable
              isOptionEqualToValue={(option, value) => option.id === value.id}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Salesman"
                  autoComplete="off"
                  // required
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} sx={{
              disply: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <Typography
              sx={{
                fontWeight: "bold",
                textAlign: "right",
                backgroundColor: "#ba68c8",
                color: "#fff",
                padding: "8px 20px",
              }}
            >
              Total : {count ? count : 0}
            </Typography>
          </Grid>
          <Grid container spacing={1} className="p-3"  justifyContent="space-between">
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <TextField
                  fullWidth
                  label="Enter Barcode"
                  variant="outlined"
                  value={code}
                  onChange={handleCodeChange}
                  // onChange={(e) => setCode(e.target.value)}
                  onKeyPress={handleCodeKeyPress}
                />
              </Grid>
             
            <Grid  sx={{ display: "flex" }}>
              <Typography
                sx={{
                  fontWeight: "bold",
                  textAlign: "right",
                  backgroundColor: "green",
                  color: "#fff",
                  padding: "19px 20px",
                }}
              >
                Scanned Total : {tempData.length}
              </Typography>

              <Typography
                sx={{
                  fontWeight: "bold",
                  textAlign: "right",
                  backgroundColor: "red",
                  color: "#fff",
                  padding: "19px 20px",
                }}
              >
                Balance Total : {count ? count - tempData.length : 0 }
              </Typography>
            </Grid>

             
            </Grid>
     
        </Grid>
        {/* <TempData tempData={tempData}/> */}
        <Box position="relative" width="100%" height="100%">

        {/* <Grid className="w-full">
          <TableContainer className={classes.tblRoot}>
            <Table stickyHeader className={classes.table}>
              <TableHead className={classes.tblHeader} sx={{position: "sticky",top: 0,}}>
                <TableRow className={classes.tablrow}>
                  <TableCell
                    className={classes.tblCell}
                    sx={{ borderLeft: "0.5px solid  #ccc" }}
                  >
                    Sno
                  </TableCell>
                  <TableCell className={classes.tblCell}>Barcode</TableCell>
                  <TableCell className={classes.tblCell}>
                    Product Name
                  </TableCell>
                <TableCell className={classes.tblCell}>Action</TableCell>
                </TableRow>
              </TableHead>
            
                <TableBody  sx={{height:"500px",overflow:"auto",}}>
          {rows.map((value, idx) => (
            <MemoizedTableRow key={idx} value={value} idx={idx} handleDeleteRow={handleDeleteRow} />
          ))}
        </TableBody>
            </Table>
            <div className={classes.pagination}>
        <TablePagination
          rowsPerPageOptions={[50, 25, 10]}
          component="div"
          count={tempData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </div>
          </TableContainer>
     
        </Grid> */}
        <Grid className="w-full" sx={{ height: "400px" }} >
          
  <TableContainer className={classes.tblRoot}   sx={{ maxHeight: "400px", overflow: "auto" }}  ref={tableRef}>
    <Table stickyHeader className={classes.table}>
      <TableHead className={classes.tblHeader} sx={{ position: "sticky", top: 0, backgroundColor: "white", zIndex: 2 }}>
        <TableRow className={classes.tablrow}>
          <TableCell
            className={classes.tblCell}
            sx={{ borderLeft: "0.5px solid  #ccc" }}
          >
            Sno
          </TableCell>
          <TableCell className={classes.tblCell}>Barcode</TableCell>
          <TableCell className={classes.tblCell}>Product Name</TableCell>
          <TableCell className={classes.tblCell}>Action</TableCell>
        </TableRow>
      </TableHead>
      <TableBody >
        {rows.map((value, idx) => (
          <MemoizedTableRow key={idx} value={value} idx={idx} handleDeleteRow={handleDeleteRow} />
        ))}
      </TableBody>
    </Table>

    {/* Pagination Footer */}
  
 

  </TableContainer>
  <div className={classes.pagination}
     style={{ width: "100%",backgroundColor: "white",  }}
 
     >
      <TablePagination
        rowsPerPageOptions={[10, 25, 50, 100]}
        component="div"
        count={tempData.length}
        
        rowsPerPage={rowsPerPage}
        page={page}
        pageCount={pageCount}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        labelDisplayedRows={({ from, to, count }) => {
          const pageCount = Math.ceil(count / rowsPerPage); // Calculate the page count
          return `${page + 1}`; // Custom format with "< 1 >"
        }}
      />
    </div>
</Grid>

        {/* <Grid className="w-full" sx={{ height: "500px" }}>
      <TableContainer className={classes.tblRoot} sx={{ overflow: "auto" }} ref={tableRef}>
        <Table stickyHeader className={classes.table}>
          <TableHead className={classes.tblHeader} sx={{ position: "sticky", top: 0 }}>
            <TableRow className={classes.tablrow}>
              <TableCell
                className={classes.tblCell}
                sx={{ borderLeft: "0.5px solid  #ccc" }}
              >
                Sno
              </TableCell>
              <TableCell className={classes.tblCell}>Barcode</TableCell>
              <TableCell className={classes.tblCell}>Product Name</TableCell>
              <TableCell className={classes.tblCell}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((value, idx) => (
              <MemoizedTableRow key={idx} value={value} idx={idx} handleDeleteRow={handleDeleteRow} />
            ))}
          </TableBody>
        </Table>
        <div className={classes.pagination}>
        <TablePagination
          rowsPerPageOptions={[10,20,30]}
          component="div"
          count={tempData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </div>
      </TableContainer>

    </Grid> */}
            {/* Loader Overlay */}
            {loading && (
          <Box 
            display="flex" 
            justifyContent="center" 
            alignItems="center" 
            position="absolute" 
            top={0} 
            left={0} 
            right={0} 
            bottom={0} 
            bgcolor="rgba(255, 255, 255, 0.7)" // Optional: background color for the overlay
            zIndex={10}
          >
            <CircularProgress size={50}/> {/* Material UI spinner */}
          </Box>
        )}
        </Box>
        <Grid container sx={{ marginTop: "30px" }}>
         <Grid item xs={6} sx={{ textAlign: "start" }}>
        <Button 
        
        onClick={() => {
          handleOpen();
          getPendingDetails();
        }}
        disabled={isPendingDisabled}
        sx={{
          backgroundColor: isPendingDisabled ? "gray" : "primary.main",
          color: isPendingDisabled ? "#fff !important" : "#fff !important",
          "&:hover": {
            backgroundColor: isPendingDisabled ? "gray" : "primary.dark",
          },
        }}
        >
        Pending
      </Button>

        </Grid>
         <Grid item xs={6} sx={{ textAlign: "end" }}>
      

          {roleId == 1 || roleId == 2 ?
              <Button
                size="small"
                sx={{ margin: 1 }}
                startIcon={<DeleteForeverOutlinedIcon />}
                variant="outlined"
                // onClick={handleCancel}
                onClick={handleCancelButton}
              >
                Cancel
              </Button>
               : 
               null
          }
        
              <Button
                size="small"
                sx={{ margin: 1 }}
                startIcon={<Save />}
                variant="outlined"
                onClick={handleSaveClick}
                // onClick={handleSubmit}
              >
                Save
              </Button>
                <Button
                        size="small"
                        variant="contained"
                        sx={{ margin: 1, backgroundColor: "red !important" }}
                        startIcon={<ExitToApp />}
                        onClick={handleExit}
                      >
                        Exit
                      </Button>
        </Grid>
        </Grid>
         {/* Popup */}
      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle>Pending Stocks
        {/* <strong style={{ textAlign: "left" }}>Total Qty: </strong> */}
        <IconButton
      aria-label="close"
      onClick={handleClose}
      sx={{
        position: "absolute",
        right: 8,
        top: 8,
        color: (theme) => theme.palette.grey[500],
      }}
    >
      <CloseIcon />
      </IconButton>
        </DialogTitle>
        <DialogContent>
          <Grid className="w-full" sx={{ overflow: "auto" }}>
            <TableContainer className={classes.tblRoot}>
              <Table stickyHeader className={classes.table}>
                <TableHead className={classes.tblHeader} sx={{position: "sticky",top: 0,}}>
                  <TableRow>
                    <TableCell>Sno</TableCell>
                    <TableCell>Sub Category</TableCell>
                    <TableCell>Qty</TableCell>
                    <TableCell>Mrp</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {pendingData.map((value, idx) => (
                    <TableRow key={idx}>
                      <TableCell>{idx + 1}</TableCell>
                      <TableCell>{value.subcategory_name}</TableCell>
                      <TableCell>{Number(value.qty || 0).toFixed(0)}</TableCell>
                      <TableCell>{Number(value.mrp || 0).toFixed(0)}</TableCell>
                    </TableRow>
                  ))}                
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </DialogContent>
      </Dialog>
      <Dialog
    open={isDialogOpen}
    onClose={closeDialog}
    aria-labelledby="confirm-dialog-title"
    aria-describedby="confirm-dialog-description"
>
    <DialogContent>
        <DialogContentText id="confirm-dialog-description">
        Are you sure you want to save?
        </DialogContentText>
    </DialogContent>
    <DialogActions>
        <Button onClick={closeDialog}  variant="outlined" color="primary">
            Cancel
        </Button>
        <Button onClick={handleSubmit} variant="contained" color="primary" autoFocus>
            Confirm
        </Button>
    </DialogActions>
</Dialog>

      </Grid>
      <DialogCancel
        onClickCancel={onClickCancelDelete}
        onClickExit={onClickExit}
        dialogClose={dialogClose}
        setDialogClose1={setDialogClose1}
      />
          <Dialog
    open={isDialogOpenCancel}
    onClose={closeDeleteDialog}
    aria-labelledby="confirm-dialog-title"
    aria-describedby="confirm-dialog-description"
>
    <DialogContent>
        <DialogContentText id="confirm-dialog-description">
        Are you sure you want to cancel?
        </DialogContentText>
    </DialogContent>
    <DialogActions>
        <Button onClick={closeDeleteDialog}  variant="outlined" color="primary">
            Cancel
        </Button>
        <Button onClick={handleCancel} variant="contained" color="primary" autoFocus>
            Confirm
        </Button>
    </DialogActions>
</Dialog>
    </Fragment>
  );
};

export default ClosingStockExpense;
